import { h } from "preact";
import { useCallback, useEffect, useState } from "preact/hooks";
import { RoutableProps } from "preact-router";
import { ScanPackQR } from "../../components/ScanPackQR";
import "./styles.scss";
import { SerialNumberType } from "../../data/types";
import { Snackbar, SnackbarShowCommand } from "../../components/Snackbar";
import { useCommand, useForceUpdate } from "../../hooks";
import { addProductToDatabase, getProductsWithType, getProductTypeByGtin, getProductTypeByName, getSerialNumberInfo, Product, ProductType } from "../../api/product-api";
import { Alert } from "../../components/Alert";
import { createGS1SearchExec } from "../../utils";

const gtinRegex = /^(\d{14}|\d{13}|\d{12}|\d{8})$/m;
const elementLotRegex =  /^.{1,20}$/m; // /^([0-9A-Za-z-_+=]{1,20})$/m;
const elementLot8DateRegex =  /^\d{8}$/m; // /^([0-9A-Za-z-_+=]{1,20})$/m;
const elementLotRegexGs1 = createGS1SearchExec([{ ai: "01" }, { ai: "10" }]); // /^.*01(\d{14}).*10([0-9A-Za-z-_+=]{1,20})/m;

export function BatchLotRegister(props: RoutableProps) {
    const [gtin, setGtin] = useState("");
    const [lot, setLot] = useState("");
    const [isProductUsingLot, setIsProductUsingLot] = useState(false);

    const [isLotValid, setIsLotValid] = useState(false);
    const [serialNumbers, setSerialNumbers] = useState([] as { lot: string, serialNumber: string, valid: boolean, registered?: boolean }[]);
    const [typeInfo, setTypeInfo] = useState(null as { type: SerialNumberType, data: Product } | null);
    const [productType, setProductType] = useState(null as null | ProductType);
    const forceUpdate = useForceUpdate();
    const showSnackbar = useCommand<SnackbarShowCommand>();
    // const [existingEStopSerialNumbers, setExistingEStopSerialNumbers] = useState([] as Product[]);

    const addBatch = () => {
        if (!productType || !isProductUsingLot) {
            return;
        }

        const serial = productType.gtin + "-" + lot;

        if (serialNumbers.find(v => serial === v.serialNumber)) {
            return;
        }

        setSerialNumbers([
            ...serialNumbers,
            {
                lot: lot,
                serialNumber: serial,
                valid: false
            }
        ]);
    };

    useEffect(() => {
        setIsLotValid(false);

        if (!lot) {
            setTypeInfo(null);
            return;
        }

        if (!productType) {
            return;
        }

        if (productType.serialNumberType?.name === "gtin-lot-8-date") {
            if (!lot.match(elementLot8DateRegex)) {
                setTypeInfo(null);
                showSnackbar.run("Podany numer LOT jest w złym formacie", "error", "error", 3000);
                return;
            }
        }

        if (!lot.match(elementLotRegex)) {
            setTypeInfo(null);
            showSnackbar.run("Podany numer LOT jest w złym formacie", "error", "error", 3000);
            return;
        }

        setIsLotValid(true);
    }, [lot, productType]);

    useEffect(() => {
        getProductTypeByGtin(gtin).then((v) => {
            console.log(v);
            if (v?.serialNumberType && v.serialNumberType.name !== "gtin-lot" && v.serialNumberType.name !== "gtin-lot-8-date") {
                setIsProductUsingLot(false);
            }
            else {
                setIsProductUsingLot(true);
            }

            setProductType(v);
        }).catch(() => setProductType(null));
    }, [gtin]);

    useEffect(() => {
        getSerialNumberInfo(serialNumbers.map(v => v.serialNumber)).then((products) => {
            for (let i = 0; i < serialNumbers.length; i++) {
                serialNumbers[i].valid = true;
                delete serialNumbers[i].registered;
            }

            for (let i = 0; i < products.length; i++) {
                const product = products[i];
                const serialNumberData = serialNumbers.find(v => v.serialNumber === product.serialNumber);

                if (serialNumberData) {
                    serialNumberData.valid = false;
                }
            }

            forceUpdate();
        });
    }, [serialNumbers]);

    return <div class="batch-lot-register-page">
        <Snackbar doShow={showSnackbar}/>
        <div class="paper serial-input">
            <ScanPackQR onRead={(data) => {
                const text = JSON.parse(data) as string;
                let match = elementLotRegexGs1.exec(text);

                if (match && match.length === 3) {
                    setGtin(match[1].trim());
                    setLot(match[2].trim());
                    return;
                }

                match = gtinRegex.exec(text);

                if (match && match.length === 2) {
                    setGtin(match[1].trim());
                    setLot("");
                }
                else if (productType && text.match(elementLotRegex)) {
                    setLot(text);
                }
            }}/>
            <div style="margin-top: 10px;">
                <label>
                    <span style="margin-right: 10px;">Wprowadź numer GTIN</span>
                    <input value={gtin} onChange={e => {
                        setGtin(e.currentTarget.value.trim());
                        // e.currentTarget.setCustomValidity(!e.currentTarget.value.match(gtinRegex) ? "Nieprawidłowy numer GTIN" : "");
                    }} />
                </label>
            </div>
            {productType ? <div class="paper-2" style="margin-top: 10px; padding: 10px">
                <div><span style="color: #a7a7a7">Rodzaj produktu:</span> {productType.name}</div>
                <div style="margin-top: 10px;"><span style="color: #a7a7a7">Opis:</span> {productType.brand}</div>
            </div> : null}
            {!isProductUsingLot ? <div style="margin-top: 10px;">
                <Alert type="error">Produkt nie używa numeru partii LOT do identyfikacji</Alert>
            </div> : null}
            <div style="margin-top: 10px;">
                <label>
                    <span style="margin-right: 10px;">Podaj lub zeskanuj numer LOT</span>
                    <input value={lot} onChange={e => {
                        setLot(e.currentTarget.value.trim());
                        // e.currentTarget.setCustomValidity(!e.currentTarget.value.match(elementLotRegex) ? "Nieprawidłowy numer seryjny" : "");
                    }} />
                </label>
            </div>
            {gtin && (!productType || !productType.gtin)  ? <div style="margin-top: 10px;">
                <Alert type="error">Nie znaleziono produktu o podanym numerze GTIN</Alert>
            </div> : null}
            <div style="margin-top: 10px;">
                <button class={productType && productType.gtin && isLotValid && isProductUsingLot ? "" : "disabled"} onClick={() => addBatch()}>Dodaj Partie</button>
            </div>
            <div class="paper-2 serial-list">
                <h2 style="padding-bottom: 10px;">Numery partii LOT do rejestracji</h2>
                <table style="width: 100%; text-align: left;">
                    <thead>
                        <th>LOT</th>
                        <th>Numer seryjny partii</th>
                        <th>Walidacja</th>
                        <th>Usuń</th>
                    </thead>
                    <tbody>
                        {serialNumbers.map((v, i) => <tr class={(v.registered === true ? "register-success" : v.registered === false ? "register-fail" : "")}>
                            <td style="white-space: nowrap">{v.lot}</td>
                            <td style="width: 100%">{v.serialNumber}</td>
                            <td class="validation">{!v.valid ? <button class="icon r26 error tooltip-accent tooltip-bottom" data-tooltip="Partia o podanym numerze seryjnym istnieje już w bazie danych">priority_high</button>
                                : <button class="icon r26 success tooltip-accent tooltip-bottom" data-tooltip="Numer seryjny jest poprawny">check</button>}
                            </td>
                            <td class="remove">
                                <button type="button" class="flat icon error tooltip-top" data-tooltip="Usuwa pozycje z listy" onClick={() => {
                                    serialNumbers.splice(i, 1);
                                    setSerialNumbers([...serialNumbers]);
                                }}>close</button>
                            </td>
                        </tr>)}
                    </tbody>
                </table>
            </div>
            <div style="margin-top: 10px">
                <button type="button" class={serialNumbers.length > 0 && serialNumbers.every(v => v.valid) && productType ? "" : "disabled"} onClick={async () => {
                    if (!productType) {
                        return;
                    }

                    const promises = [];

                    for(let i = 0; i < serialNumbers.length; i++) {
                        const serialNumberData = serialNumbers[i];

                        promises.push(addProductToDatabase(productType.name, serialNumberData.lot).then(() => {
                            serialNumberData.registered = true;
                            forceUpdate();
                        }).catch((ex) => {
                            serialNumberData.registered = false;
                            forceUpdate();
                            throw ex;
                        }));
                    }

                    try {
                        await Promise.all(promises);
                        showSnackbar.run("Wszystkie partie zostały zarejestrowane pomyślnie", "success", "check");
                    }
                    catch(ex) {
                        showSnackbar.run("Nie udało się zarejestrować niektórych partii", "error", "check");
                    }
                }}>Zarejestruj</button>
            </div>
        </div>
        {/* <div class="paper" style="margin-top: 10x">
            <table>
                <tbody>
                    {existingEStopSerialNumbers.map(v => <tr>
                        <td>{v.serialNumber.split("-")[1]}</td>
                        <td>{v.serialNumber}</td>
                        <td>{v.creator}</td>
                        <td>{v.createdAt}</td>
                    </tr>)}
                </tbody>
            </table>
        </div> */}
    </div>;
}
